import plainAxios from '../axios.plain';
import api from '../axios.config';

export const JobService = {
  getJobs: async () => {
    const response = await plainAxios.get('/candidates/jobs');
    return response.data;
  },
  getJobById: async (id) => {
    const response = await plainAxios.get(`/candidates/jobs/${id}`);
    return response.data;
  },
  applyToJob: async (jobId, payload) => {
    const response = await api.post(`/candidates/jobs/${jobId}/apply`, payload);
    return response;
  },
};
